// Waterfall Attributes
export const ATTR_WATERFALL = "waterfall";
export const ATTR_WATERFALL_PRELOAD = "waterfall-preload";
export const ATTR_WATERFALL_POSTLOAD = "waterfall-postload";
export const ATTR_WATERFALL_CONTENT = "waterfall-content";
// Debug
export const ATTR_DEBUG_MODE = "waterfall-debug-mode";
export const ATTR_ADVANCED_DEBUG_MODE = "waterfall-advanced-debug-mode";
// A11Y`
export const ATTR_A11Y = "waterfall-a11y";
export const ATTR_A11Y_CONTAINER_MESSAGE = "waterfall-a11y-container-message";
export const ATTR_A11Y_CONTAINER_ROLE = "waterfall-a11y-container-role";
export const ATTR_A11Y_CONTAINER_ROLE_DESCRIPTION_MESSAGE = "waterfall-a11y-container-role-description-message";
export const ATTR_A11Y_ENABLED = "waterfall-a11y-enabled";
export const ATTR_A11Y_FIRST_SLIDE_MESSAGE = "waterfall-a11y-first-slide-message";
export const ATTR_A11Y_ID = "waterfall-a11y-id";
export const ATTR_A11Y_ITEM_ROLE_DESCRIPTION_MESSAGE = "waterfall-a11y-item-role-description-message";
export const ATTR_A11Y_LAST_SLIDE_MESSAGE = "waterfall-a11y-last-slide-message";
export const ATTR_A11Y_NEXT_SLIDE_MESSAGE = "waterfall-a11y-next-slide-message";
export const ATTR_A11Y_NOTIFICATION_CLASS = "waterfall-a11y-notification-class";
export const ATTR_A11Y_PAGINATION_BULLET_MESSAGE = "waterfall-a11y-pagination-bullet-message";
export const ATTR_A11Y_PREV_SLIDE_MESSAGE = "waterfall-a11y-prev-slide-message";
export const ATTR_A11Y_SCROLL_ON_FOCUS = "waterfall-a11y-scroll-on-focus";
export const ATTR_A11Y_SLIDE_LABEL_MESSAGE = "waterfall-a11y-slide-label-message";
export const ATTR_A11Y_SLIDE_ROLE = "waterfall-a11y-slide-role";
// Breakpoints
export const ATTR_LMOBILE_CENTERED_SLIDES = "waterfall-centered-slides-lmobile";
export const ATTR_LMOBILE_SLIDES_PER_VIEW = "waterfall-slides-per-view-lmobile";
export const ATTR_LMOBILE_SLIDES_PER_GROUP = "waterfall-slides-per-group-lmobile";
export const ATTR_LMOBILE_SPACE_BETWEEN = "waterfall-space-between-lmobile";
export const ATTR_TABLET_CENTERED_SLIDES = "waterfall-centered-slides-tablet";
export const ATTR_TABLET_SLIDES_PER_VIEW = "waterfall-slides-per-view-tablet";
export const ATTR_TABLET_SLIDES_PER_GROUP = "waterfall-slides-per-group-tablet";
export const ATTR_TABLET_SPACE_BETWEEN = "waterfall-space-between-tablet";
export const ATTR_DESKTOP_CENTERED_SLIDES = "waterfall-centered-slides-desktop";
export const ATTR_DESKTOP_SLIDES_PER_VIEW = "waterfall-slides-per-view-desktop";
export const ATTR_DESKTOP_SLIDES_PER_GROUP = "waterfall-slides-per-group-desktop";
export const ATTR_DESKTOP_SPACE_BETWEEN = "waterfall-space-between-desktop";
export const ATTR_LARGE_CENTERED_SLIDES = "waterfall-centered-slides-large";
export const ATTR_LARGE_SLIDES_PER_VIEW = "waterfall-slides-per-view-large";
export const ATTR_LARGE_SLIDES_PER_GROUP = "waterfall-slides-per-group-large";
export const ATTR_LARGE_SPACE_BETWEEN = "waterfall-space-between-large";
export const ATTR_XLARGE_CENTERED_SLIDES = "waterfall-centered-slides-xlarge";
export const ATTR_XLARGE_SLIDES_PER_VIEW = "waterfall-slides-per-view-xlarge";
export const ATTR_XLARGE_SLIDES_PER_GROUP = "waterfall-slides-per-group-xlarge";
export const ATTR_XLARGE_SPACE_BETWEEN = "waterfall-space-between-xlarge";
// Controller
export const ATTR_CONTROLLER = "waterfall-controller";
export const ATTR_CONTROLLER_BY = "waterfall-controller-by";
export const ATTR_CONTROLLER_INVERSE = "waterfall-controller-inverse";
// Effect
export const ATTR_EFFECT_CROSSFADE = "waterfall-effect-crossfade";
export const ATTR_COVERFLOW_DEPTH = "waterfall-coverflow-depth";
export const ATTR_COVERFLOW_MODIFIER = "waterfall-coverflow-modifier";
export const ATTR_COVERFLOW_ROTATE = "waterfall-coverflow-rotate";
export const ATTR_COVERFLOW_SCALE = "waterfall-coverflow-scale";
export const ATTR_COVERFLOW_SLIDE_SHADOWS = "waterfall-coverflow-slide-shadows";
export const ATTR_COVERFLOW_STRETCH = "waterfall-coverflow-stretch";
export const ATTR_FLIP_LIMIT_ROTATION = "waterfall-flip-limit-rotation";
export const ATTR_FLIP_SLIDE_SHADOWS = "waterfall-flip-slide-shadows";
export const ATTR_CUBE_SHADOW = "waterfall-cube-shadow";
export const ATTR_CUBE_SHADOW_OFFSET = "waterfall-cube-shadow-offset";
export const ATTR_CUBE_SHADOW_SCALE = "waterfall-cube-shadow-scale";
export const ATTR_CUBE_SLIDE_SHADOWS = "waterfall-cube-slide-shadows";
export const ATTR_CARDS_PER_SLIDE_OFFSET = "waterfall-cards-per-slide-offset";
export const ATTR_CARDS_PER_SLIDE_ROTATE = "waterfall-cards-per-slide-rotate";
export const ATTR_CARDS_ROTATE = "waterfall-cards-rotate";
export const ATTR_CARDS_SLIDE_SHADOWS = "waterfall-cards-slide-shadows";
// General
export const ATTR_ALLOW_SLIDE_NEXT = "waterfall-allow-slide-next";
export const ATTR_ALLOW_SLIDE_PREV = "waterfall-allow-slide-prev";
export const ATTR_ALLOW_TOUCH_MOVE = "waterfall-allow-touch-move";
export const ATTR_AUTO_HEIGHT = "waterfall-auto-height";
export const ATTR_BREAKPOINTS_BASE = "waterfall-breakpoints-base";
export const ATTR_CENTER_INSUFFICIENT_SLIDES = "waterfall-center-insufficient-slides";
export const ATTR_CENTERED_SLIDES = "waterfall-centered-slides";
export const ATTR_CENTERED_SLIDES_BOUNDS = "waterfall-centered-slides-bounds";
export const ATTR_CONTAINER_MODIFIER_CLASS = "waterfall-container-modifier-class";
export const ATTR_CREATE_ELEMENTS = "waterfall-create-elements";
export const ATTR_CSS_MODE = "waterfall-css-mode";
export const ATTR_DIRECTION = "waterfall-direction";
export const ATTR_EDGE_SWIPE_DETECTION = "waterfall-edge-swipe-detection";
export const ATTR_EDGE_SWIPE_THRESHOLD = "waterfall-edge-swipe-threshold";
export const ATTR_EFFECT = "waterfall-effect";
export const ATTR_ENABLED = "waterfall-enabled";
export const ATTR_EVENTS_PREFIX = "waterfall-events-prefix";
export const ATTR_FOCUSABLE_ELEMENTS = "waterfall-focusable-elements";
export const ATTR_FOLLOW_FINGER = "waterfall-follow-finger";
export const ATTR_GRAB_CURSOR = "waterfall-grab-cursor";
export const ATTR_HEIGHT = "waterfall-height";
export const ATTR_INIT = "waterfall-init";
export const ATTR_INITIAL_SLIDE = "waterfall-initial-slide";
export const ATTR_LAZY_PRELOAD_PREV_NEXT = "waterfall-lazy-preload-prev-next";
export const ATTR_LAZY_PRELOADER_CLASS = "waterfall-lazy-preloader-class";
export const ATTR_LONG_SWIPES = "waterfall-long-swipes";
export const ATTR_LONG_SWIPES_MS = "waterfall-long-swipes-ms";
export const ATTR_LONG_SWIPES_RATIO = "waterfall-long-swipes-ratio";
export const ATTR_LOOP = "waterfall-loop-mode";
export const ATTR_LOOP_ADD_BLANK_SLIDES = "waterfall-loop-add-blank-slides";
export const ATTR_LOOP_ADD_ADDITIONAL_SLIDES = "waterfall-loop-additional-slides";
export const ATTR_LOOP_PREVENTS_SLIDING = "waterfall-loop-prevents-sliding";
export const ATTR_MAX_BACKFACE_HIDDEN_SLIDES = "waterfall-max-backface-hidden-slides";
export const ATTR_NESTED = "waterfall-nested";
export const ATTR_NO_SWIPING = "waterfall-no-swiping";
export const ATTR_NO_SWIPING_CLASS = "waterfall-no-swiping-class";
export const ATTR_NO_SWIPING_SELECTOR = "waterfall-no-swiping-selector";
export const ATTR_NORMALIZE_SLIDE_INDEX = "waterfall-normalize-slide-index";
export const ATTR_OBSERVE_SLIDE_PARENTS = "waterfall-observe-parents";
export const ATTR_OBSERVE_SLIDE_CHILDREN = "waterfall-observe-slide-children";
export const ATTR_OBSERVER = "waterfall-observer";
export const ATTR_ONE_WAY_MOVEMENT = "waterfall-data-one-way-movement";
export const ATTR_PASSIVE_LISTENERS = "waterfall-passive-listeners";
export const ATTR_PREVENT_CLICKS = "waterfall-prevent-clicks";
export const ATTR_PREVENT_CLICKS_PROPAGATION = "waterfall-prevent-clicks-propagation";
export const ATTR_PREVENT_INTERACTION_ON_TRANSITION = "waterfall-prevent-interaction-on-transition";
export const ATTR_RESISTANCE = "waterfall-resistance";
export const ATTR_RESISTANCE_RATIO = "waterfall-resistance-ratio";
export const ATTR_RESIZE_OBSERVER = "waterfall-resize-observer";
export const ATTR_REWIND = "waterfall-rewind";
export const ATTR_ROUND_LENGTHS = "waterfall-round-lengths";
export const ATTR_RUN_CALLBACKS_ON_INIT = "waterfall-run-callbacks-on-init";
export const ATTR_SET_WRAPPER_SIZE = "waterfall-set-wrapper-size";
export const ATTR_SHORT_SWIPES = "waterfall-short-swipes";
export const ATTR_SIMULATE_TOUCH = "waterfall-simulate-touch";
export const ATTR_SLIDE_ACTIVE_CLASS = "waterfall-slide-active-class";
export const ATTR_SLIDE_CLASS = "waterfall-slide-class";
export const ATTR_SLIDE_BLANK_CLASS = "waterfall-slide-blank-class";
export const ATTR_SLIDE_FULLY_VISIBLE_CLASS = "waterfall-slide-fully-visible-class";
export const ATTR_SLIDE_NEXT_CLASS = "waterfall-slide-next-class";
export const ATTR_SLIDE_PREV_CLASS = "waterfall-slide-prev-class";
export const ATTR_SLIDE_TO_CLICKED_SLIDE = "waterfall-slide-to-clicked-slide";
export const ATTR_SLIDE_VISIBLE_CLASS = "waterfall-slide-visible-class";
export const ATTR_SLIDES_OFFSET_AFTER = "waterfall-slides-offset-after";
export const ATTR_SLIDES_OFFSET_BEFORE = "waterfall-slides-offset-before";
export const ATTR_SLIDES_PER_GROUP = "waterfall-slides-per-group";
export const ATTR_SLIDES_PER_GROUP_AUTO = "waterfall-slides-per-group-auto";
export const ATTR_SLIDES_PER_GROUP_SKIP = "waterfall-slides-per-group-skip";
export const ATTR_SLIDES_PER_VIEW = "waterfall-slides-per-view";
export const ATTR_SPACE_BETWEEN = "waterfall-space-between";
export const ATTR_SPEED = "waterfall-speed";
export const ATTR_SWIPE_HANDLER = "waterfall-swipe-handler";
export const ATTR_SWIPER_ELEMENT_NODE_NAME = "waterfall-swiper-element-node-name";
export const ATTR_THRESHOLD = "waterfall-threshold";
export const ATTR_TOUCH_ANGLE = "waterfall-touch-angle";
export const ATTR_TOUCH_EVENTS_TARGET = "waterfall-touch-events-target";
export const ATTR_TOUCH_MOVE_STOP_PROPAGATION = "waterfall-touch-move-stop-propagation";
export const ATTR_TOUCH_RATIO = "waterfall-touch-ratio";
export const ATTR_TOUCH_RELEASE_ON_EDGES = "waterfall-touch-release-on-edges";
export const ATTR_TOUCH_START_FORCE_PREVENT_DEFAULT = "waterfall-touch-start-force-prevent-default";
export const ATTR_TOUCH_START_PREVENT_DEFAULT = "waterfall-touch-start-prevent-default";
export const ATTR_UNIQUE_NAV_ELEMENTS = "waterfall-unique-nav-elements";
export const ATTR_UPDATE_ON_WINDOW_RESIZE = "waterfall-update-on-window-resize";
export const ATTR_URL = "waterfall-url";
export const ATTR_USER_AGENT = "waterfall-user-agent";
export const ATTR_VIRTUAL_TRANSLATE = "waterfall-virtual-translate";
export const ATTR_WATCH_OVERFLOW = "waterfall-watch-overflow";
export const ATTR_WATCH_SLIDES_PROGRESS = "waterfall-watch-slides-progress";
export const ATTR_WIDTH = "waterfall-width";
export const ATTR_WRAPPER_CLASS = "waterfall-wrapper-class";
// Hash Navigation
export const ATTR_HASH_REPLACE_STATE = "waterfall-hash-replace-state";
export const ATTR_HASH_WATCH_STATE = "waterfall-hash-watch-state";
// History Navigation
export const ATTR_HISTORY_KEEP_QUERY = "waterfall-history-keep-query";
export const ATTR_HISTORY_KEY = "waterfall-history-key";
export const ATTR_HISTORY_REPLACE_STATE = "waterfall-history-replace-state";
export const ATTR_HISTORY_ROOT = "waterfall-history-root";
// Keyboard
export const ATTR_KEYBOARD_ENABLED = "waterfall-keyboard-enabled";
export const ATTR_KEYBOARD_ONLY_IN_VIEWPORT = "waterfall-keyboard-only-in-viewport";
export const ATTR_KEYBOARD_PAGE_UP_DOWN = "waterfall-keyboard-page-up-down";
// Mousewheel
export const ATTR_MOUSE_ENABLED = "waterfall-mouse-enabled";
export const ATTR_MOUSE_EVENTS_TARGET = "waterfall-mouse-events-target";
export const ATTR_MOUSE_FORCE_TO_AXIS = "waterfall-mouse-force-to-axis";
export const ATTR_MOUSE_INVERT = "waterfall-mouse-invert";
export const ATTR_MOUSE_NO_MOUSE_WHEEL_CLASS = "waterfall-mouse-no-mouse-wheel-class";
export const ATTR_MOUSE_RELEASE_ON_EDGES = "waterfall-mouse-release-on-edges";
export const ATTR_MOUSE_SENSITIVITY = "waterfall-mouse-sensitivity";
export const ATTR_MOUSE_THRESHOLD_DELTA = "waterfall-mouse-threshold-delta";
export const ATTR_MOUSE_THRESHOLD_TIME = "waterfall-mouse-threshold-time";
// Grid
export const ATTR_GRID_ROWS = "waterfall-grid-rows";
export const ATTR_GRID_FILL = "waterfall-grid-fill";
// Navigation
export const ATTR_NAVIGATION_DISABLED_CLASS = "waterfall-navigation-disabled-class";
export const ATTR_NAVIGATION_ENABLED = "waterfall-navigation-enabled";
export const ATTR_NAVIGATION_HIDDEN_CLASS = "waterfall-navigation-hidden-class";
export const ATTR_NAVIGATION_HIDE_ON_CLICK = "waterfall-navigation-hide-on-click";
export const ATTR_NAVIGATION_LOCK_CLASS = "waterfall-navigation-lock-class";
export const ATTR_NAVIGATION_NAVIGATION_DISABLED_CLASS = "waterfall-navigation-navigation-disabled-class";
// Pagination
export const ATTR_PAGINATION_TYPE = "waterfall-pagination-type";
export const ATTR_PAGINATION_BULLET_CLASS = "waterfall-pagination-bullet-class";
export const ATTR_PAGINATION_BULLET_ACTIVE_CLASS = "waterfall-pagination-bullet-active-class";
export const ATTR_PAGINATION_CLICKABLE = "waterfall-pagination-clickable";
export const ATTR_PAGINATION_CLICKABLE_CLASS = "waterfall-pagination-clickable-class";
export const ATTR_PAGINATION_CURRENT_CLASS = "waterfall-pagination-current-class";
export const ATTR_PAGINATION_DYNAMIC_BULLETS = "waterfall-pagination-dynamic-bullets";
export const ATTR_PAGINATION_DYNAMIC_MAIN_BULLETS = "waterfall-pagination-dynamic-main-bullets";
export const ATTR_PAGINATION_ENABLED = "waterfall-pagination-enabled";
export const ATTR_PAGINATION_HIDDEN_CLASS = "waterfall-pagination-hidden-class";
export const ATTR_PAGINATION_HIDE_ON_CLICK = "waterfall-pagination-hide-on-click";
export const ATTR_PAGINATION_HORIZONTAL_CLASS = "waterfall-pagination-horizontal-class";
export const ATTR_PAGINATION_LOCK_CLASS = "waterfall-pagination-lock-class";
export const ATTR_PAGINATION_MODIFIER_CLASS = "waterfall-pagination-modifier-class";
export const ATTR_PAGINATION_PAGINATION_DISABLED_CLASS = "waterfall-pagination-pagination-disabled-class";
export const ATTR_PAGINATION_PROGRESSBAR_FILL_CLASS = "waterfall-pagination-progressbar-fill-class";
export const ATTR_PAGINATION_PROGRESSBAR_OPPOSITE = "waterfall-pagination-progressbar-opposite";
export const ATTR_PAGINATION_PROGRESSBAR_OPPOSITE_CLASS = "waterfall-pagination-progressbar-opposite-class";
export const ATTR_PAGINATION_TOTAL_CLASS = "waterfall-pagination-total-class";
export const ATTR_PAGINATION_VERTICAL_CLASS = "waterfall-pagination-vertical-class";
// Playback
export const ATTR_AUTOPLAY = "waterfall-autoplay-mode";
export const ATTR_SMOOTH_AUTOPLAY = "waterfall-smooth-autoplay";
export const ATTR_DELAY = "waterfall-delay";
export const ATTR_DISABLE_ON_INTERACTION = "waterfall-disable-on-interaction";
export const ATTR_REVERSE_DIRECTION = "waterfall-reverse-direction";
export const ATTR_PAUSE_ON_MOUSE_ENTER = "waterfall-pause-on-mouse-enter";
export const ATTR_STOP_ON_LAST_SLIDE = "waterfall-stop-on-last-slide";
export const ATTR_WAIT_FOR_TRANSITION = "waterfall-wait-for-transition";
// Autoplay Control
export const ATTR_AUTOPLAY_CONTROL_ENABLED = "waterfall-autoplay-control-enabled";
export const ATTR_AUTOPLAY_CONTROL_DEFAULT_STATE = "waterfall-autoplay-control-default-state";
// Free Mode
export const ATTR_FREE_MODE_ENABLED = "waterfall-free-mode-enabled";
export const ATTR_FREE_MODE_MINIMUM_VELOCITY = "waterfall-free-mode-minimum-velocity";
export const ATTR_FREE_MODE_MOMENTUM = "waterfall-free-mode-momentum";
export const ATTR_FREE_MODE_MOMENTUM_BOUNCE = "waterfall-free-mode-momentum-bounce";
export const ATTR_FREE_MODE_MOMENTUM_BOUNCE_RATIO = "waterfall-free-mode-momentum-bounce-ratio";
export const ATTR_FREE_MODE_MOMENTUM_RATIO = "waterfall-free-mode-momentum-ratio";
export const ATTR_FREE_MODE_MOMENTUM_VELOCITY_RATIO = "waterfall-free-mode-momentum-velocity-ratio";
export const ATTR_FREE_MODE_STICKY = "waterfall-free-mode-sticky";
// Scrollbar
export const ATTR_SCROLLBAR_DRAG_CLASS = "waterfall-scrollbar-drag-class";
export const ATTR_SCROLLBAR_DRAG_SIZE = "waterfall-scrollbar-drag-size";
export const ATTR_SCROLLBAR_DRAGGABLE = "waterfall-scrollbar-draggable";
export const ATTR_SCROLLBAR_ENABLED = "waterfall-scrollbar-enabled";
export const ATTR_SCROLLBAR_HIDE = "waterfall-scrollbar-hide";
export const ATTR_SCROLLBAR_HORIZONTAL_CLASS = "waterfall-scrollbar-horizontal-class";
export const ATTR_SCROLLBAR_LOCK_CLASS = "waterfall-scrollbar-lock-class";
export const ATTR_SCROLLBAR_SCROLLBAR_DISABLED_CLASS = "waterfall-scrollbar-scrollbar-disabled-class";
export const ATTR_SCROLLBAR_VERTICAL_CLASS = "waterfall-scrollbar-vertical-class";
export const ATTR_SCROLLBAR_SNAP_ON_RELEASE = "waterfall-scrollbar-snap-on-release";
// Thumbs
export const ATTR_THUMBS = "waterfall-thumbs";
export const ATTR_THUMBS_AUTO_SCROLL_OFFSET = "waterfall-thumbs-auto-scroll-offset";
export const ATTR_THUMBS_MULTIPLE_ACTIVE_THUMBS = "waterfall-thumbs-multiple-active-thumbs";
export const ATTR_THUMBS_SLIDE_THUMB_ACTIVE_CLASS = "waterfall-slide-thumb-active-class";
export const ATTR_THUMBS_CONTAINER_CLASS = "waterfall-thumbs-container-class";
// Manipulation
export const ATTR_MANIPULATION_ADD_SLIDE = "waterfall-add-slide";
export const ATTR_MANIPULATION_ADD_INDEX = "waterfall-add-index";
export const ATTR_MANIPULATION_APPEND_SLIDE = "waterfall-append-slide";
export const ATTR_MANIPULATION_PREPEND_SLIDE = "waterfall-prepend-slide";
export const ATTR_MANIPULATION_REMOVE_SLIDE = "waterfall-remove-slide";
export const ATTR_MANIPULATION_REMOVE_INDEX = "waterfall-remove-index";
export const ATTR_MANIPULATION_REMOVE_ALL_SLIDES = "waterfall-remove-all-slides";
// Zoom
export const ATTR_ZOOM = "waterfall-zoom";
export const ATTR_ZOOM_ENABLED = "waterfall-zoom-enabled";
export const ATTR_ZOOM_CONTAINER_CLASS = "waterfall-zoom-container-class";
export const ATTR_ZOOM_LIMIT_TO_ORIGINAL_SIZE = "waterfall-zoom-limit-to-original-size";
export const ATTR_ZOOM_MAX_RATIO = "waterfall-zoom-max-ratio";
export const ATTR_ZOOM_MIN_RATIO = "waterfall-zoom-min-ratio";
export const ATTR_ZOOM_PAN_ON_MOUSE_MOVE = "waterfall-zoom-pan-on-mouse-move";
export const ATTR_ZOOM_TOGGLE = "waterfall-zoom-toggle";
export const ATTR_ZOOMED_SLIDE_CLASS = "waterfall-zoomed-slide-class";
export const ATTR_ZOOM_FADE = "waterfall-zoom-fade";
// Parallax
export const ATTR_PARALLAX_ENABLED = "waterfall-parallax-enabled";
export const ATTR_PARALLAX = "data-swiper-parallax";
export const ATTR_PARALLAX_X = "data-swiper-parallax-x";
export const ATTR_PARALLAX_Y = "data-swiper-parallax-y";
export const ATTR_PARALLAX_SCALE = "data-swiper-parallax-scale";
export const ATTR_PARALLAX_OPACITY = "data-swiper-parallax-opacity";
export const ATTR_PARALLAX_DURATION = "data-swiper-parallax-duration";
// Callbacks
export const ATTR_CALLBACK_SLIDE_CHANGE = "waterfall-callback-slide-change";

// Extras ??? //FIXME - this probably should be removed
export const ATTR_PLAYBACK_MODE = "waterfall-playback-mode";
